"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sha3_384 = exports.sha256 = exports.compareVersions = void 0;
__exportStar(require("./AsyncStoredSerializedValue"), exports);
__exportStar(require("./CachedMemoryStorage"), exports);
__exportStar(require("./CachedStoredValue"), exports);
__exportStar(require("./CachedValue"), exports);
__exportStar(require("./Citr"), exports);
__exportStar(require("./Coffer"), exports);
__exportStar(require("./CompletablePromise"), exports);
__exportStar(require("./dumps"), exports);
__exportStar(require("./Emitter"), exports);
__exportStar(require("./EncryptedSessionStorage"), exports);
__exportStar(require("./Estimator"), exports);
__exportStar(require("./Parsec"), exports);
__exportStar(require("./LocalSessionStorage"), exports);
__exportStar(require("./MemorySessionStorage"), exports);
__exportStar(require("./Parsec"), exports);
__exportStar(require("./ParsecExceptions"), exports);
__exportStar(require("./ParsecSession"), exports);
__exportStar(require("./Passwords"), exports);
__exportStar(require("./PrefixedSessionStorage"), exports);
__exportStar(require("./SimpleBoss"), exports);
__exportStar(require("./StoredSerializedValue"), exports);
__exportStar(require("./text_tools"), exports);
__exportStar(require("./tools"), exports);
__exportStar(require("./UNS"), exports);
__exportStar(require("./UnversalKeys"), exports);
__exportStar(require("./Zedentials"), exports);
const tools_1 = require("./tools");
// we will add it to unicrypto instead
// export type BossPrimitive = string | null | number | Date | boolean | BossArray | BossObject | Uint8Array;
// /*eslint @typescript-eslint/no-empty-interface: "off" */
// export interface BossArray extends Array<BossPrimitive> {}
// export interface BossObject extends Record<string,BossPrimitive> {}
/**
 * Simple compare semver version strings.
 * @param v1
 * @param v2
 */
function compareVersions(v1, v2) {
    var _a, _b;
    const parts1 = v1.split('.').map(x => +x);
    const parts2 = v2.split('.').map(x => +x);
    const n = parts1.length < parts2.length ? parts2.length : parts1.length;
    for (let i = 0; i < n; i++) {
        const p1 = (_a = parts1[i]) !== null && _a !== void 0 ? _a : 0;
        const p2 = (_b = parts2[i]) !== null && _b !== void 0 ? _b : 0;
        if (p1 < p2)
            return -1;
        if (p1 > p2)
            return +1;
    }
    return 0;
}
exports.compareVersions = compareVersions;
const unicrypto_1 = require("unicrypto");
async function sha256(data) {
    if (!(data instanceof Uint8Array))
        data = tools_1.utf8ToBytes(data);
    return await unicrypto_1.SHA.getDigest("sha256", data);
}
exports.sha256 = sha256;
async function sha3_384(data) {
    if (!(data instanceof Uint8Array))
        data = tools_1.utf8ToBytes(data);
    return await unicrypto_1.SHA.getDigest("sha3_384", data);
}
exports.sha3_384 = sha3_384;
//# sourceMappingURL=index.js.map